<template>
  <div class="basic register-entrance">
    <!-- <div class="basic-header">
      <p>- 展位预定信息 -</p>
    </div> -->
    <div class="top-title2">
      <div class="line"></div>
      Reserve your space<span>*</span>
    </div>
    <div class="choice">
      <div class="select-box">
        <div class="select-content" style="padding:0;">
          <div class="top">
            <div class="top-title">I am interested in exhibiting at NHNE CHINA 2022. Please reserve a booth of:</div>
            <RadioGroup v-model="areaType" @on-change="change1">
              <div class="top-item">
                <div>
                  <Radio label="Shell scheme"></Radio>
                  <InputNumber :max="99999" :min="1" v-model="hallCount" :disabled="areaType !== 'Shell scheme'" style="width:140px;"></InputNumber>
                  <span style="padding-left: 10px">×9㎡</span>
                </div>
              </div>
              <div class="top-item">
                <div>
                  <Radio label="Raw space"></Radio>
                  <InputNumber :max="9999" :min="1" v-model="showArea" :disabled="areaType !== 'Raw space'" style="width:140px;"></InputNumber>
                  <span style="padding-left: 10px">㎡</span>
                </div>
              </div>
            </RadioGroup>
            <Checkbox v-model="isNeedActivity">I am interested in advertising & sponsor opportunity</Checkbox>
          </div>
          <div class="bottom">
            <div class="box">
              <Row class="line" type="flex" justify="center" align="middle">
                <Col flex="auto" span="8">Check out the price
                </Col>
                <Col span="8" flex="auto">Unit price <br />（USD）
                </Col>
                <Col span="8">Early bird price
                <br />
                （before Aug.31）
                </Col>
              </Row>
              <Row class="line" type="flex" justify="center" align="middle">
                <Col span="8">Raw space
                </Col>
                <Col span="8">230
                </Col>
                <Col span="8">185
                </Col>
              </Row>
              <Row class="line" type="flex" justify="center" align="middle">
                <Col span="8">Shell scheme
                </Col>
                <Col span="8">2,700/ 9sqm
                </Col>
                <Col span="8">2,400/ 9sqm
                </Col>
              </Row>
            </div>
            <div class="tip">
              <div class="dot">Raw space only available when booth over 18sqm</div>
              <div class="dot">Shell scheme including basic construction, carpet, lighting spotlights, power socket, table, chairs, reception desk, fascia board</div>
            </div>
          </div>
        </div>
      </div>
      <div class="gap"></div>
      <div class="select-box">
        <div class="top-title2">
          <div class="line"></div>
          Specify your Product Category
        </div>
        <div class="select-content">
          <div class="selectbox">
            <Tree :data="arr" show-checkbox check-directly @on-check-change="onSelectChange"></Tree>
            <div class="other">
              <Checkbox label="Others, please specify">Others, please specify<Input v-model="other2" style="width: 100px;" class="under-btn" /></Checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="handle-box">
      <Button @click="validHandle" class="handle-box-btn" type="primary">提交</Button>
    </div> -->
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  components: {},
  props: {},
  data () {
    return {
      company1: '',
      isNeedActivity: false,
      productName: '',
      areaName: [],
      other2: '',
      areaType: '',
      showArea: null,
      hallCount: null,
      arr: [
        {
          title: 'FITNESS AND HEALTH',
          expand: true,
          children: [
            { title: 'Commercial Training Equipment' },
            { title: 'Home Fitness' },
            { title: 'Functional Training' },
            { title: 'Physio/Rehabilitation' },
            { title: 'EMS' },
            { title: 'Diagnostic and Analytic' },
            { title: 'Posture Correction' },
            { title: 'Aqua Fitness' },
            { title: 'Group Fitness' },
            { title: 'Teenager Training' },
            { title: 'Yoga/Pilates' },
            { title: 'Fighting Fit' },
            { title: 'Massage/Vibration' },
            { title: 'Household Healthcare Tools' },
          ]
        },
        {
          title: 'SPORTS NUTRITION', expand: false,
          children: [
            { title: 'Sports Nutrition Supplements' },
            { title: 'Dietary Food' },
            { title: 'Sports Drinks' },
            { title: 'Shake Bottle / Drinks Systems' },
            { title: 'Ingredients of Sports Nutrition' },
            { title: 'Fresh Ingredients' },
            { title: 'Healthy Food' },
          ]
        },
        {
          title: 'FASHION', expand: false,
          children: [
            { title: 'Training Gears' },
            { title: 'Functional Sportswear' },
            { title: 'Sports App / Wearables' },
            { title: 'Accessories' },
            { title: 'Swimwear' },
          ]
        },
        {
          title: 'INTERIOR AND SERVICE',
          expand: false,
          children: [
            { title: 'IT-Systems' },
            { title: 'Gym/Club Facilities' },
            { title: 'Gym/Club Decoration' },
            { title: 'Pool Related' },
            { title: 'Education/Consulting' },
            { title: 'Security/Disinfection' },
          ]
        },
        {
          title: 'BEAUTY AND WELLNESS',
          expand: false,
          children: [
            { title: 'Cosmetics Apparatus' },
            { title: 'Skin Care Cosmetics' },
            { title: 'Beauty Spa' },
            { title: 'Tanning / Body Care' },
            { title: 'Body Slimming' },
          ]
        },
      ]
    };
  },
  methods: {
    ...mapActions({
      getExhibitionById: 'registerdModule/getExhibitionById',
    }),
    async getExhibitionHandle () {
      let res = await this.getExhibitionById('57D57E6B-E417-4B44-90F7-A855C96886AD');
      if (res) {
        this.company1 = res;
        console.log('getExhibitionHandle', this.company1);
      }
    },
    async validHandle () {
      if (this.areaType) {
        if (this.areaType === 'Shell scheme' && !this.hallCount) {
          this.$Message.error("Please enter the number of shell scheme");
          return Promise.resolve({ valid: false });
        }
        if (this.areaType === 'Raw space' && this.showArea < 9) {
          this.$Message.error("Please enter the area of raw space(9㎡ minimum)");
          return Promise.resolve({ valid: false });
        }
      } else {
        this.$Message.error("Please select your reserved booth");
        return Promise.resolve({ valid: false });
      }
      if (this.other2) {
        this.areaName.map((c, index) => {
          if (c === 'Others, please specify') {
            this.areaName[index] = c + ':' + this.other2;
          }
        });
      }
      let showArea = this.showArea;
      if (this.areaType === 'Shell scheme') {
        showArea = this.hallCount * 9;
      }
      let res = {
        exhibition: [this.company1],
        ApplyCompanyOrder: {
          isNeedActivity: this.isNeedActivity,
          areaType: this.areaType,
          hallCount: this.hallCount || 0,
          showArea: showArea,
          areaName: this.areaName.join(';'),
        }
      }
      return Promise.resolve({ valid: true, ...res });
    },
    change1 (e) {
      this.showArea = null;
      this.hallCount = null;
    },
    onSelectChange (e) {
      let arr = []
      e.forEach(e => {
        arr.push(e.title);
      });
      this.areaName = arr;
      console.log('areaName', this.areaName);
    }
  },
  created () {
    this.getExhibitionHandle();
  },
}


</script>

<style lang="scss" scoped>
.basic {
  /deep/ {
    .ivu-radio-checked .ivu-radio-inner {
      border-color: #d00300 !important;
    }
    .ivu-radio-inner:after {
      background-color: #d00300;
    }
    .ivu-switch-checked {
      border-color: #d00300;
      background-color: #d00300;
    }
  }
  &-header {
    width: 100%;
    height: 50px;
    background-color: #d00300;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    p {
      line-height: 50px;
      font-size: 15px;
    }
    span {
      width: 30px;
      height: 1px;
      background-color: #fff;
      margin: 0 15px;
    }
  }
  &-title {
    line-height: 48px;
    font-size: 18px;
    background-color: #f2f2f2;
    color: #333;
    margin-bottom: 30px;
    padding-left: 30px;
    span {
      font-size: 12px;
    }
  }
}
.choice {
  margin-bottom: 30px;
}
.choicebox {
  min-height: 686px;
  background-color: #fff;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  &.active {
    background-color: #fdf7f9;
    border: solid 1px #d00300;
    .select {
      opacity: 1;
    }
    .choicebox-content ::v-deep {
      .ivu-radio-group-item {
        &:nth-child(odd) {
          background-color: #f5eff1;
        }
      }
    }
    .choicebox-tool {
      background-color: #f5eff1;
    }
  }
  .select {
    position: absolute;
    opacity: 0;
    text-align: center;
    top: 0;
    right: 0;
    width: 84px;
    height: 32px;
    line-height: 32px;
    background-color: #d00300;
    border-radius: 0px 0px 0px 10px;
    border: solid 1px #d00300;
    font-size: 12px;
    color: #fff;
  }
  &-top {
    padding: 30px 30px 20px;
    .txt1 {
      font-size: 15px;
      color: #333;
      font-weight: 500;
      margin-bottom: 10px;
    }
    .txt2 {
      font-size: 12px;
      color: #666;
      margin-bottom: 8px;
    }
  }
  &-content {
    padding: 15px;
    .title {
      text-align: center;
      font-size: 15px;
      color: #333;
      margin-bottom: 20px;
    }
    .item {
      display: flex;
      align-items: center;
      flex: 1;
      &-box {
        width: 50%;
      }
      &-box2 {
        width: 50%;
        p {
          font-size: 12px;
          color: #333;
          font-weight: normal;
        }
      }
    }
    ::v-deep {
      .ivu-radio-group-item {
        width: 100%;
        display: flex;
        align-items: center;
        min-height: 74px;
        padding: 15px 10px 15px 20px;
        &:nth-child(odd) {
          background-color: #f7f7f7;
        }
      }
    }
  }
  &-tool {
    height: 73px;
    background-color: #f7f7f7;
    padding-left: 24px;
    display: flex;
    align-items: center;
  }
}
.select-box {
  .select-title {
    line-height: 48px;
    background-color: #f2f2f2;
    padding-left: 31px;
    font-size: 18px;
  }
}
.under-btn {
  ::v-deep {
    .ivu-input {
      position: relative;
      top: -2px;
      border: none;
      border-bottom: 1px solid #bfbfbf;
      border-radius: 0;
      &:hover,
      &:active {
        outline: none;
        box-shadow: none;
      }
    }
  }
}
.select-content-title {
  font-size: 15px;
  color: #333;
  margin-bottom: 18px;
}
.top {
  padding: 15px;
  color: #333;
  border-bottom: 1px solid #e6e6e6;
  &-txt {
    font-size: 12px;
    padding-left: 29px;
    padding-bottom: 10px;
  }
  &-txt2 {
    color: #999;
  }
  &-title {
    font-size: 15px;
    margin-bottom: 28px;
  }
  &-item {
    margin-bottom: 26px;
  }
}
.bottom {
  padding: 15px;
}
.box {
  text-align: center;
  .line {
    height: 42px;
    font-size: 12px;
    color: #333;
    &:first-child {
      font-size: 12px;
      color: #fff;
      background-color: #d00300 !important;
      .ivu-col {
        border-right: 1px solid #fff;
      }
    }
    &:nth-child(odd) {
      background-color: #fff;
    }
    &:nth-child(even) {
      background-color: #f2fafe;
    }
    .ivu-col {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      border-right: 1px solid #d9f3ff;
      &:last-child {
        border-color: transparent !important;
      }
    }
  }
}
.tip {
  margin-top: 30px;
  font-size: 10px;
  color: #666;
}
.dot {
  position: relative;
  padding-left: 10px;
  &:before {
    content: "";
    position: absolute;
    left: 0;
    width: 4px;
    height: 4px;
    background-color: #999;
    border-radius: 50%;
    top: 10px;
    margin-top: -2px;
  }
}
.last {
  margin-bottom: 0 !important;
}
.top-title2 {
  line-height: 50px;
  align-items: center;
  padding-left: 15px;
  font-size: 15px;
  color: #333;
  font-weight: 600;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e6e6e6;
  &.s-noline {
    border-bottom: none;
  }
  .line {
    content: "";
    width: 3px;
    height: 15px;
    background-color: #d00300;
    margin-right: 7px;
  }
  span {
    font-size: 15px;
    .upload-btn2 {
      width: 105px;
      height: 105px;
      border: dotted 1px #bfbfbf;
      text-align: center;
      margin: 10px 15px;
      border-radius: 4px;
      position: relative;
      margin-left: 10px;
      img {
        position: absolute;
        width: 100%;
        height: 100%;
        margin: 0;
        top: 0;
        left: 0;
        z-index: 2;
      }
    }
    color: #f00;
  }
  &-left {
    flex: 1;
    text-align: right;
    display: flex;
    justify-content: flex-end;
    padding-right: 15px;
  }
}
.selectbox {
  margin: 15px;
  background-color: #fff;
  border-radius: 3px;
  overflow: hidden;
  border: solid 1px #e5e5e5;
  .other {
    line-height: 40px;
    width: 100%;
    padding-left: 14px;
    input {
      background: transparent;
    }
  }
  ::v-deep {
    .ivu-tree {
      > ul {
        padding-top: 2px;
        padding-bottom: 2px;
        border-bottom: solid 1px #e5e5e5;
        position: relative;
        padding-left: 10px;
        &:last-child {
          boder-bottom: none;
        }
      }
      .ivu-tree-arrow {
        position: absolute;
        right: 10px;
        top: 20px;
        margin-top: -10px;
      }
      .ivu-tree-arrow i {
        color: #999;
      }
    }
  }
}
.gap {
  height: 15px;
  background: #f7f7f7;
  width: 100%;
}
</style>
